import React, { Component } from 'react';
import moment from 'moment';
import ReactTable from 'react-table';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
// import './Editions.scss';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button, UncontrolledTooltip } from "reactstrap";
import update from 'immutability-helper';
import Geral from '../../Utils/Geral';

class ProductList extends Component {

    constructor(props) {
        super(props);

        this.toggleModal = this.toggleModal.bind(this);
        this.selecionaProduto = this.selecionaProduto.bind(this);
        this.mudaStatusProduto = this.mudaStatusProduto.bind(this);
        this.toggleStatusAlteracao = this.toggleStatusAlteracao.bind(this);
        this.refreshTableProduct = this.refreshTableProduct.bind(this);
        this.excluirProduto = this.excluirProduto.bind(this);

        this.Configurations = new Configurations();
        this.Geral = new Geral();

        this.state = {
            openModal: false,
            idProduto: null,
            isLoadingProdutos: true,
            modalStatusProduto: false,
            metodoStatusProduto: "ativar",
            listaProdutos: [],
            // listaProdutos: this.Geral.produtosMOCK,
        }

        // this.listaProdutos = this.Geral.produtosMOCK;

        this.columns = [
            {
                Header: 'id',
                accessor: 'idProduto',
                className: 'text-center pointer',
                width: 50

            },
            {
                Header: 'Nome',
                accessor: 'nome',
                className: 'text-center pointer',
                width: 180

            },
            // {
            //     Header: 'Sigla',
            //     accessor: 'sigla',
            //     className: 'text-center pointer',
            //     width: 90

            // },
            // {
            //     Header: 'Valor unit.',
            //     accessor: 'valorUnitario',
            //     className: 'text-center pointer',
            //     width: 90,
            //     Cell: row => (row.value ? <span>R$ {row.value.toFixed(2).replace(".", ",")}</span> : <span>erro</span>)

            // },
            {
                Header: 'Tipo',
                accessor: 'tipoProduto',
                className: 'text-center pointer',
                width: 90

            },
            {
                Header: 'Dt. criação',
                className: 'text-center pointer',
                accessor: 'dtCriacao',
                width: 130,
                Cell: row => (row.value ? <span>{moment(row.value).format("DD/MM/YY")}</span> : <span>erro</span>)
            },
            {
                Header: 'Dt. modificação',
                className: 'text-center pointer',
                accessor: 'dtModificacao',
                width: 130,
                Cell: row => (row.value ? <span>{moment(row.value).format("DD/MM/YY")}</span> : <span>erro</span>)
            },
            {
                Header: 'Usuário',
                accessor: 'usuario',
                className: 'text-center pointer',
                width: 120
            },
            {
                Header: 'Status',
                className: 'text-center pointer',
                accessor: 'ativo',
                Cell: row => (<h6 className="m-0"><span className={`badge badge-${row.value ? 'success' : 'secondary badge-opacity'}`}>{row.value ? 'Ativo' : 'Inativo'}</span></h6>),
                width: 120,
            },
            {
                Header: '',
                className: 'text-center pointer',
                Cell: row => {
                    const _ativo = row.original.ativo,
                        _functionBtn = _ativo ? "desativar" : "ativar",
                        _classIcon = _ativo ? `far fa-eye-slash` : `far fa-eye`,
                        _textTooltip = _ativo ? "desativar produto" : "ativar produto";
                    return (
                        <div className="row no-gutters">
                            <div className="col-12 icones" id={`Tooltip-${row.original.idProduto}`}>
                                {row.original.loading ? (
                                    <div className="spinner-border spinner-border-sm text-primary" role="status" />
                                ) : (
                                        <button onClick={() => this.confirmaStatusAlteracao(row.original.idProduto, row.original.nome, _functionBtn)}>
                                            <i className={`${_classIcon}`}></i>
                                        </button>
                                    )}
                                <UncontrolledTooltip placement="top" target={`Tooltip-${row.original.idProduto}`}>
                                    {_textTooltip}
                                </UncontrolledTooltip>
                            </div>
                        </div>
                    )
                }
                // width: 90
            },
            // {
            //     Header: '',
            //     className: 'pointer text-center text-danger',
            //     Cell: row => (<div onClick={() => this.excluirEdicao(row.original.numeroEdicao)}><i className="far fa-trash-alt"></i></div>)
            // },
        ]
    }

    componentWillMount() {
        this.carregaProdutos();
    }

    carregaProdutos() {
        this.setState({ isLoadingProdutos: true })
        axios.get(this.Configurations.apiBasePath + "/produtos").then(response => {
            this.setState({ listaProdutos: response.data.produtos })
        }).catch(err => console.log(err)).finally(() => {
            this.setState({ isLoadingProdutos: false })
        });
    }

    excluirProduto(_idProduto) {
        alert(`Excluir edição ${_idProduto}`)
    }

    mudaStatusProduto() {
        this.toggleStatusAlteracao();
        const _index = this.state.listaProdutos.findIndex(item => parseInt(item.idProduto, 10) === parseInt(this.state.idProdStatusAlteracao, 10));
        this.setState({ listaProdutos: update(this.state.listaProdutos, { [_index]: { loading: { $set: true } } }) })

        axios.put(this.Configurations.apiBasePath + `/produtos/${this.state.idProdStatusAlteracao}/${this.state.metodoStatusProduto}`).then(response => { }).catch(err => {
            console.log(err);
        }).finally(() => {
            this.carregaProdutos();
        });
    }

    confirmaStatusAlteracao(_idProd, _nomeProd, _metodo) {
        this.toggleStatusAlteracao();
        this.setState({
            idProdStatusAlteracao: _idProd,
            nomeProdStatusAlteracao: _nomeProd,
            metodoStatusProduto: _metodo
        })
    }

    refreshTableProduct(o) {
        // this.carregaProdutos(o);
    }

    selecionaProduto(_idProd) {
        this.props.history.push({ pathname: `/produtos/detalhes/${_idProd}` })
    }

    toggleModal() {
        this.setState({
            naoCarregaEdicoes: !this.state.openModal,
            openModal: !this.state.openModal,
        }, () => {
            if (!this.state.openModal) {
                this.carregaProdutos();
                this.resetModalInfos();
            }
        })
    }

    toggleStatusAlteracao() {
        this.setState({ modalStatusProduto: !this.state.modalStatusProduto })
    }

    render() {
        return (
            <div className="row edition-list">
                <div className="col-12">
                    <div className="row no-gutters align-items-center">
                        <div className="col-12 col-lg-8 text-center text-lg-left">
                            <h2 className="title-1">Lista de Produtos</h2>
                        </div>
                        <div className="col-12 col-lg-4 text-center text-lg-right">
                            <div className="row no-gutters">
                                <div className="col py-2 py-lg-0">
                                    <button className="btn btn-outline-info mx-2" type="button" name="novoProduto" onClick={() => this.props.history.push({ pathname: '/produtos/detalhes/novo-produto' })}>
                                        Cadastrar novo produto
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`col-12`}>
                    {this.state.isLoadingProdutos ? (
                        <div className="row no-gutters">
                            <div className="col-12 text-center py-5">
                                <div className="spinner-border text-primary" role="status" />
                            </div>
                        </div>
                    ) : (
                            <div className="row no-gutters">
                                <div className={`col-12`}>
                                    <div className="row no-gutters">
                                        <div className={`col-12 text-center text-lg-left`}>
                                            <p className="py-2 m-0">Clique no produto para obter mais informações.</p>
                                            <div className="card">
                                                <div className="card-body p-0">
                                                    <ReactTable
                                                        data={this.state.listaProdutos}
                                                        columns={this.columns}
                                                        // onFetchData={this.refreshTableProduct}
                                                        defaultPageSize={25}
                                                        // pages={this.state.paginasEdicoes}
                                                        page={this.state.pagina}
                                                        // manual
                                                        // pageSize={this.state.limite}
                                                        loading={this.state.isLoadingProdutos}
                                                        className="-striped -highlight"
                                                        headerClassName="ebs-table-header"
                                                        previousText='Anterior'
                                                        nextText='Próximo'
                                                        loadingText='Carregando...'
                                                        noDataText='Nenhuma edição encontrada.'
                                                        pageText='Página'
                                                        ofText='de'
                                                        rowsText='linhas'
                                                        getTdProps={(state, rowInfo, column, instance) => {
                                                            return {
                                                                onClick: (e, handleOriginal) => {

                                                                    if (rowInfo) {
                                                                        if (column.Header === "") handleOriginal();
                                                                        else this.selecionaProduto(rowInfo.original.idProduto)
                                                                    }
                                                                }
                                                            }
                                                        }}
                                                    />

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                </div>

                <Modal isOpen={this.state.modalStatusProduto} toggle={this.toggleStatusAlteracao}>
                    <ModalHeader toggle={this.toggleStatusAlteracao}>
                        {this.state.metodoStatusProduto === 'ativar' ? `Ativar produto` : `Desativar produto`}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.metodoStatusProduto === 'ativar' ? (
                            <p className="m-0">Deseja confirmar a ativação do produto <strong>{this.state.nomeProdStatusAlteracao}?</strong></p>
                        ) : (
                                <p className="m-0">Deseja desativar o produto <strong>{this.state.nomeProdStatusAlteracao}</strong>?</p>
                            )}
                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingStatusProduto ? (
                            <div className="spinner-border text-primary" role="status" />
                        ) : (
                                <Button disabled={this.state.isLoadingStatusProduto} color={`${this.state.metodoStatusProduto === 'ativar' ? `success` : `danger`}`} onClick={this.mudaStatusProduto}>confirmar</Button>
                            )}
                        {' '}<Button color="secondary" onClick={() => this.setState({ modalStatusProduto: !this.state.modalStatusProduto })}>voltar</Button>
                    </ModalFooter>
                </Modal>

            </div>
        )
    }
}

export default ProductList;